import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import { REQUEST } from '@knorr-bremse-portals/ngx-components';

@Injectable({
  providedIn: 'root',
})
export class BaseLocationService {

  public readonly origin: string;
  public readonly host: string;
  public readonly hostname: string;
  public readonly port: string;
  public readonly protocol: string;

  public constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
        this.host = window.location.host;
        this.hostname = window.location.hostname;
        this.port = window.location.port;
        this.protocol = window.location.protocol;
    } else {
        const request = inject(REQUEST);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.host = request.get('host')!;
        this.hostname = request.hostname;
        this.port = this.host.split(':')[1] || '';
        this.protocol = environment.local ? 'http:' : 'https:';
    }

    this.origin = `${this.protocol}//${this.host}`;

  }

}
